import { useState } from 'react';

import { useNavigate, useLocation } from 'react-router';

import { ROUTES } from 'enums/ROUTES';
import { RouteValue, ValueOf } from 'types';

import { NavigationBar } from 'components/NavigationBar';

import { useQuery } from '@apollo/client';
import { USER_PROFILE } from '../../apollo-client/queries/getUserProfile';
import { UserProfile } from '../../generated/graphql';
import { UserProfileDrawer } from 'components/UserProfileDrawer';
import { defaultRegions, defaultVendorName, regions } from 'cache';

export const Header: (p: { onToggleSidebar: () => void; sidebarIsOpen: boolean }) => JSX.Element = ({
  onToggleSidebar,
  sidebarIsOpen,
}) => {
  const [drawerIsOpen, setDrawerIsOpen] = useState(false);
  const location = useLocation();
  const history = useNavigate();
  const onRouteChange = (route: RouteValue): void => history(route);
  const activePath = location?.pathname as ValueOf<typeof ROUTES>;

  const { data } = useQuery<{ userProfile: UserProfile }>(USER_PROFILE, {
    fetchPolicy: 'network-only',
    onCompleted: (res) => {
      regions(res.userProfile.preferences.regions);
      defaultVendorName(res.userProfile.vendorName);
      defaultRegions(res.userProfile.preferences.regions);
    },
  });

  return (
    <>
      <NavigationBar
        sideBarIsOpen={sidebarIsOpen}
        onToggleSideBar={onToggleSidebar}
        routes={ROUTES}
        activePath={activePath}
        onClickMenuItem={onRouteChange}
        onClickUserProfile={(): void => setDrawerIsOpen(true)}
        userProfile={data?.userProfile}
      />

      <UserProfileDrawer isActive={drawerIsOpen} onClose={(): void => setDrawerIsOpen(false)} userPreferences={data} />
    </>
  );
};
